class BannerSlider {
	constructor() {
		const bannerHome = document.querySelector(".banner-home");
		if (!bannerHome) {
			return;
		}

		const prevArrow = bannerHome.querySelector('.swiper-button-prev');
		const nextArrow = bannerHome.querySelector('.swiper-button-next');
		const swiperPagination = bannerHome.querySelector('.swiper-pagination');

		const sliderImages = new Swiper(".banner-slideshow-images", {
			speed: 1000,
			loop: true,
			loopPreventsSlide: false,
			effect: 'fade',
			fadeEffect: {
				crossFade: false
			},
		});

		const sliderText = new Swiper(".banner-slideshow-text", {
			autoplay: {
				delay: 6500,
			},
			speed: 0,
			loop: true,
			loopPreventsSlide: false,
			allowTouchMove: true,
			effect: 'slide',
			pagination: {
				el: swiperPagination,
				clickable: true,
				type: "bullets",
			}
		});

		prevArrow.addEventListener("click", () => {
			sliderText.slidePrev();
		});
		nextArrow.addEventListener("click", () => {
			sliderText.slideNext();
		});

		sliderText.on("slideNextTransitionStart", (swiper) => {
			sliderImages.slideNext();
		});

		sliderText.on("slidePrevTransitionStart", (swiper) => {
			sliderImages.slidePrev();
		});

	}
}